import React, { Component } from 'react';
import './css/main.css';
import { Helmet } from "react-helmet";

// Default setup
import Navigation from './layout/navigation/Navigation';
import Footer from './layout/footer/Footer';
import ProjectInfo from './layout/portfolio/ProjectInfo';
import ImageGridFront from './layout/portfolio/ImageGridFront';
import BriefIcon from './layout/hero/BriefIcon';
import GalleryGridx2 from './layout/portfolio/GalleryGridx2';
import ImageGridx1 from './layout/portfolio/ImageGridx1';
import VideoGridx1 from './layout/portfolio/VideoGridx1';
import WarpLarge from './layout/warp/WarpLarge';
import NextUp from './layout/warp/NextUp';

import PenIcon from './asset/PenIcon';
import Front from './img/outware/anzGrow@2x.png';

// ANZ
import Grow_1 from './img/outware/anzGrowCommercial.mp4';
// SnapSendSolve
import Snap_1 from './img/outware/snapsendsolve@2x.png';
// pitch
import Opal_1 from './img/outware/OpalPitch@2x.png';
import Westpac_1 from './img/outware/WestpacPitch1@2x.png';
import Westpac_2 from './img/outware/WestpacPitch2@2x.png';

// Summary
const companyInfo = {
  title: "Australia’s most popular mobile apps",
  name: "Outware Mobile",
  themeColor: "#3383C2",
  themeTextColor: "white",
  frontImage: Front,
  role: "Visual Designer",
  fields: "Mobile Apps, UX Design, Marketing",
  time: "July 2012 – Feb 2015",
}

// how I stated working at the company
const workContent =
  {
    description: "Outware Mobile was the first place I started working as a visual desinger in Australia, exclusively creating mobile apps. As a visual designer, my responsibility was to develop concepts from wireframes on, and to communicate with developers and clients to refine the product."
  };

// Project case study
const ANZGrow = {
  summary: "Working with Coporate clients",
  titleIcon: PenIcon,
  title: "I worked closely with many Australian corporates clients.",
  paragraph: "Including ANZ, Telstra, and Nib, from sports to finance. During my time at Outware I worked and met with many companies and organisations in Australia. The highlight moment was when ANZ Grow featured the screen I worked on in their TV commercial.",
  themeColor: '#ffffff',
  textColor: '',
}

const SnapSendSolve = {
  summary: "Side Project",
  titleIcon: PenIcon,
  title: "Snap Send Solve",
  paragraph: "A side project within the company. I designed the interface and personality of 'Snap Send Solve', an incident reporting app. Snap Send Solve was designed to connect people with their local government to solve small incidents around them. For instance, you can use this app to report a big chunk of fallen gumtree branch on road. The app is loved by many users and widely used in Austalia.",
  themeColor: '#1C3B72',
  textColor: '#ffffff',
}


const Pitch = {
  summary: "The Pitch",
  titleIcon: PenIcon,
  title: "I learnt how to approach people's mind.",
  paragraph: "Creating concepts for pitching was a big part of design work at Outware. However, the opportunities are unpredictable, and the time was often too short and uncontrollable. To overcome this problem, I focused more on imagining what they would like to see, rather than what I wanted to present. Fortunately, most of my input resulted in success. Such as getting chance to design OPAL (Public transport system in Sydney)!",
  themeColor: '#ffffff',
  textColor: '',
}

const metatag = {
  title: "Portfolio ✴︎ " + companyInfo.name,
  author: "Jinju Jang",
  url: "http://jinju.io/outware",
  description: companyInfo.paragraph,
  image: "http://jinju.io" + companyInfo.frontImage
}

class PortfolioOutware extends Component {
  render() {
    return (
      <div>
        {/*Meta data*/}
        <Helmet>
          <meta charSet="utf-8"/>
          <title>{metatag.title}</title>
          <meta name="author" content={metatag.author}/>
          <meta name="description" content={metatag.description}/>

          {/*-- Google / Search Engine Tags --*/}
          <meta itemprop="name" content={metatag.title}/>
          <meta itemprop="description" content={metatag.description}/>
          <meta itemprop="image" content={metatag.image}/>

          {/*-- Open Graph / Facebook --*/}
          <meta property="og:url" content={metatag.url}/>
          <meta property="og:type" content="website"/>
          <meta property="og:title" content={metatag.title} />
          <meta property="og:description" content={metatag.description}/>
          <meta property="og:image" content={metatag.image}/>

          {/*-- Twitter --*/}
          <meta name="twitter:card" content="summary_large_image"/>
          <meta name="twitter:title" content={metatag.title}/>
          <meta name="twitter:description" content={metatag.description}/>
          <meta name="twitter:image" content={metatag.image}/>
       </Helmet>
        <Navigation />
        {/*Front page*/}
        <ImageGridFront first={companyInfo.frontImage} title={companyInfo.title} themeColor={companyInfo.themeColor}/>
        {/*Position summary*/}
        <ProjectInfo title={companyInfo.name}role={companyInfo.role} fields={companyInfo.fields} description={workContent.description} time={companyInfo.time}/>
        <GalleryGridx2 first={Westpac_1} second={Westpac_2} />

        {/*----- ANZ ------*/}
        <VideoGridx1 first={Grow_1} innerDescription={<BriefIcon summary={ANZGrow.summary} titleIcon={<PenIcon color={ANZGrow.textColor}/>} title={ANZGrow.title} paragraph={ANZGrow.paragraph} textColor={ANZGrow.textColor}/>}themeColor={ANZGrow.themeColor} true/>

        {/*----- Snap Send Solve ------*/}
        <ImageGridx1 first={Snap_1} innerDescription={<BriefIcon summary={SnapSendSolve.summary} titleIcon={<PenIcon color={SnapSendSolve.textColor}/>} title={SnapSendSolve.title} paragraph={SnapSendSolve.paragraph} textColor={SnapSendSolve.textColor}/>}themeColor={SnapSendSolve.themeColor} showTriangle/>

        {/*----- Pitch ------*/}
        <ImageGridx1 first={Opal_1} innerDescription={<BriefIcon summary={Pitch.summary} titleIcon={<PenIcon color={Pitch.textColor}/>} title={Pitch.title} paragraph={Pitch.paragraph} textColor={Pitch.textColor}/>}themeColor={Pitch.themeColor} false/>

        <NextUp
          previous="Monoshift"
          previousURL="/monoshift"
          next="Itty Bitty Apps"
          nextURL="/ittybittyapps"
        />
        <WarpLarge/>
        <Footer/>
      </div>
    );
  }
}

export default PortfolioOutware;



// WEBPACK FOOTER //
// ./src/PortfolioOutware.js